/** Positive numeric role id from a profile GET/POST payload (JSON number or numeric string). */
export function parseProfileRoleId(value: unknown): number | undefined {
    if (typeof value === "number" && Number.isFinite(value) && value > 0) {
        return value;
    }
    if (typeof value === "string" && /^\d+$/.test(value.trim())) {
        const parsed = Number(value.trim());
        return parsed > 0 ? parsed : undefined;
    }
    return undefined;
}
